module.exports = __webpack_public_path__ + "img/MoneyIcon.4846a358.svg";